module.exports = __webpack_public_path__ + "img/insurance-card-pdp.cf2d88c.png";